/* eslint-disable import/prefer-default-export */
import Vue from 'vue'
import {
	store
} from '@/store/store'
import url from '@/services/ApiServices/apiUrls'

export const globalApis = new Vue({
	methods: {
		getNotification () {
			return new Promise((resolve, reject) => {
				this.$http.get(url.getNotificationUrl)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		tenantCountryChooser () {
			return new Promise((resolve, reject) => {
				this.$http.get(url.tenantCountryChooserUrl)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						Vue.toasted.show('Error occurred while uploading Photos')
						reject(e)
					})
			})
		},
		ifscCodeData (code) {
			const getUrl = url.ifscCodeUrl + code
			return new Promise((resolve, reject) => {
				this.$http.get(getUrl)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		deliveryAddressCountryChooser () {
			return new Promise((resolve, reject) => {
				this.$http.get(url.countryChooserUrl)
					.then((res) => {
						store.dispatch('siteData/setCountryConfig', res.data)
						resolve(res)
					})
					.catch((e) => {
						// Vue.toasted.show('Error occurred while uploading Photos');
						reject(e)
					})
			})
		}
	}
})
